import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home').then(c => c.Home)
  },
  {
    path: 'scan-qr',
    loadComponent: () => import('./features/scan-qr/scan-qr').then(c => c.ScanQr)
  },
  {
    path: 'confirm',
    loadComponent: () => import('./features/confirm/confirm').then(c => c.Confirm)
  },
  {
    path: 'capture-photo',
    loadComponent: () => import('./features/capture-photo/capture-photo').then(c => c.CapturePhoto)
  },
  {
    path: 'sending',
    loadComponent: () => import('./features/sending/sending').then(c => c.Sending)
  },
  {
    path: 'success',
    loadComponent: () => import('./features/success/success').then(c => c.Success)
  }
];
